import {
  FETCH_CONTEXT,
  FETCH_CONTEXT_FULFILLED,
  FETCH_CONTEXT_REJECTED,
} from './types';

export function fetchContext(getPosContext, getPxContext) {
  return {
    type: FETCH_CONTEXT,
    payload: { getPosContext, getPxContext },
  };
}

export function fetchContextFulfilled(posContext, pxContext) {
  return {
    type: FETCH_CONTEXT_FULFILLED,
    payload: { posContext, pxContext },
  };
}

export function fetchContextRejected(error) {
  return {
    type: FETCH_CONTEXT_REJECTED,
    payload: { error },
  };
}
